import { DynamicExportCategory, DynamicExportKey } from '@Constants/dynamicExportConstants';
import { useDynamicExportOptions } from '@Hooks/Exports';
import { useTableMode } from '@Hooks/useTableModes';
import {
    FrameListAllInvoices,
    FrameListExportInvoices,
    FrameListOpenInvoices,
    invoiceTableModes,
    type InvoiceTableModes,
} from '@Modules/Billing';
import { useCallback } from 'react';

export function FrameListInvoice() {
    const { hasExportOptions } = useDynamicExportOptions(DynamicExportCategory.Invoices, DynamicExportKey.Accounting);

    const filterCallback = useCallback(
        (mode: InvoiceTableModes) => {
            if (mode === 'export') {
                return hasExportOptions;
            }
            return true;
        },
        [hasExportOptions],
    );

    const tableModeProps = useTableMode<InvoiceTableModes>('all', invoiceTableModes, filterCallback);

    switch (tableModeProps.tableModeValue) {
        case 'opos':
            return <FrameListOpenInvoices {...tableModeProps} />;
        case 'export':
            return <FrameListExportInvoices {...tableModeProps} />;
        default:
            return <FrameListAllInvoices {...tableModeProps} />;
    }
}
